module.exports = __webpack_public_path__ + "5e46bb0177b4c45cbd06deaaa3fd0a60.jpg";